import React, { useState } from 'react';
import Header from './ui/Header';
import Footer from './ui/Footer';
import CookieConsentModal from './CookieConsentModal';
import CookieManager from './CookieManager';

const Layout = ({ children }) => {
  const [isCookieManagerOpen, setIsCookieManagerOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="pt-16">
        {children}
      </main>

      <Footer onManageCookies={() => setIsCookieManagerOpen(true)} />
      <CookieConsentModal />
      <CookieManager 
        isOpen={isCookieManagerOpen} 
        onClose={() => setIsCookieManagerOpen(false)} 
      />
    </div>
  );
};

export default Layout;

